import React from "react";
import { Modal } from "antd";
import "./style.scss";
import UploadForm from "./UploadForm";
// const UploadForm = React.lazy(() => import("./UploadForm"));

function UploadPeople({ visible, location, onClose }) {
  return (
    <Modal
      centered
      closable={false}
      footer={null}
      className={"UploadPeopleModal"}
      destroyOnClose={true}
      visible={visible}
    >
      <UploadForm location={location} onClose={onClose} />
    </Modal>
  );
}

export default UploadPeople;
